import { RootState } from "../store.types"

export const selectIsMenuOpened = (state: RootState): boolean =>
  state.menu.isMenuOpened
